
import React from 'react';
import { Shield, CheckCircle, Users, Award } from 'lucide-react';

const AILeadEngineTrust = () => {
  return (
    <section className="py-16 bg-gray-50 border-t">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Trust Statement */}
          <div className="text-center mb-12">
            <p className="text-lg text-gray-700 font-medium mb-4">
              De AI Lead Engine is een initiatief van <strong>Afsprakenmaker</strong>.
            </p>
            <p className="text-gray-600">
              Gebouwd op bewezen technologie. GDPR-conform. Volledig transparant. 100% menselijk gestuurd.
            </p>
          </div>

          {/* Trust Indicators */}
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-green-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-2">GDPR-conform</h3>
              <p className="text-xs text-gray-600">
                Volledige privacy compliance
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-2">Bewezen technologie</h3>
              <p className="text-xs text-gray-600">
                Gebaseerd op bestaande tools
              </p>
            </div>

            <div className="text-center">
              <div className="bg-purple-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-2">Menselijk gestuurd</h3>
              <p className="text-xs text-gray-600">
                AI ondersteunt, mensen beslissen
              </p>
            </div>

            <div className="text-center">
              <div className="bg-orange-500/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-2">Transparant</h3>
              <p className="text-xs text-gray-600">
                Volledige openheid over proces
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AILeadEngineTrust;
